/* Driftwell — minimal, dependency-free JS */
(function () {
  // Scroll reveal (respects reduced motion via CSS)
  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15 })
    : null;
  document.querySelectorAll('.reveal').forEach(function (el) {
    if (io) io.observe(el); else el.classList.add('is-visible');
  });

  // Gallery: thumbnails + dots + arrows + swipe -> main image, with a
  // pause-aware auto-advance. Auto-advance only runs until the customer
  // touches the gallery in any way (thumb, dot, arrow, or swipe) — once
  // they've engaged, we get out of their way permanently for this page view.
  var main = document.getElementById('MainProductImage');
  var thumbs = Array.prototype.slice.call(document.querySelectorAll('.js-thumb'));
  var dots = Array.prototype.slice.call(document.querySelectorAll('.product__dot'));
  var galleryMain = document.querySelector('.product__gallery-main');
  var thumbStrip = document.getElementById('ProductThumbs');
  var gallery = document.getElementById('ProductGallery');
  var currentIndex = 0;
  var autoAdvanceTimer = null;
  var userInteracted = false;
  var galleryVisible = true;
  var prefersReducedMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function preload(index) {
    if (!thumbs.length) return;
    var i = (index + thumbs.length) % thumbs.length;
    var url = thumbs[i] && thumbs[i].dataset.full;
    if (url) { var img = new Image(); img.src = url; }
  }

  // Center the active thumbnail inside its own horizontal strip.
  //
  // We deliberately do NOT use thumb.scrollIntoView() here. scrollIntoView
  // walks up and scrolls EVERY scrollable ancestor, including the window — so
  // once the customer had scrolled down past the gallery, each auto-advance
  // tick yanked the whole page back up to reveal the thumbnail strip. Setting
  // scrollLeft on the strip moves only the strip and never touches the page
  // scroll position.
  function centerThumb(thumb, smooth) {
    if (!thumbStrip || !thumb) return;
    var stripRect = thumbStrip.getBoundingClientRect();
    var thumbRect = thumb.getBoundingClientRect();
    var offsetWithinStrip = (thumbRect.left - stripRect.left) + thumbStrip.scrollLeft;
    var target = offsetWithinStrip - (thumbStrip.clientWidth / 2) + (thumbRect.width / 2);
    var maxScroll = thumbStrip.scrollWidth - thumbStrip.clientWidth;
    target = Math.max(0, Math.min(target, maxScroll));
    if (typeof thumbStrip.scrollTo === 'function') {
      thumbStrip.scrollTo({ left: target, behavior: (smooth && !prefersReducedMotion) ? 'smooth' : 'auto' });
    } else {
      thumbStrip.scrollLeft = target;
    }
  }

  function stopAutoAdvance() {
    userInteracted = true;
    if (autoAdvanceTimer) { clearInterval(autoAdvanceTimer); autoAdvanceTimer = null; }
  }

  function startAutoAdvance() {
    if (prefersReducedMotion || userInteracted || thumbs.length < 2 || autoAdvanceTimer) return;
    autoAdvanceTimer = setInterval(function () {
      // Don't cycle images the customer can't even see — saves bandwidth and
      // guarantees no scroll side effects while they're reading further down.
      if (!galleryVisible) return;
      setActive(currentIndex + 1, { silent: true });
    }, 6000);
  }

  function setActive(index, opts) {
    if (!thumbs.length) return;
    opts = opts || {};
    currentIndex = (index + thumbs.length) % thumbs.length;
    var thumb = thumbs[currentIndex];
    if (main && thumb.dataset.full) {
      // Shopify's image_tag filter adds a srcset/sizes pair, and browsers
      // prioritize srcset over a plain src swap — so clear them or the
      // image will silently keep showing the original srcset candidate.
      main.removeAttribute('srcset');
      main.removeAttribute('sizes');
      main.src = thumb.dataset.full;
    }
    thumbs.forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
    dots.forEach(function (d) { d.classList.remove('is-active'); });
    if (dots[currentIndex]) dots[currentIndex].classList.add('is-active');
    // Keep the active thumbnail visible within its scrolling strip.
    centerThumb(thumb, !opts.silent);
    // Warm the neighbors so the next click or swipe feels instant
    preload(currentIndex + 1);
    preload(currentIndex - 1);
    // Any non-silent call is a real interaction: stop the timer for good
    if (!opts.silent) stopAutoAdvance();
  }

  thumbs.forEach(function (thumb, i) {
    thumb.addEventListener('click', function () { setActive(i); });
  });

  dots.forEach(function (dot, i) {
    dot.addEventListener('click', function () { setActive(i); });
  });

  var prevBtn = document.getElementById('GalleryPrev');
  var nextBtn = document.getElementById('GalleryNext');
  if (prevBtn) prevBtn.addEventListener('click', function () { setActive(currentIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { setActive(currentIndex + 1); });

  // Swipe support on the main image (mobile). Ignores mostly-vertical
  // gestures so page scrolling still works normally.
  if (galleryMain) {
    var touchStartX = 0;
    var touchStartY = 0;
    galleryMain.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
      touchStartY = e.changedTouches[0].clientY;
    }, { passive: true });
    galleryMain.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      if (dx < 0) { setActive(currentIndex + 1); } else { setActive(currentIndex - 1); }
    }, { passive: true });
  }

  // Pause the auto-advance whenever the gallery is scrolled out of view.
  if (gallery && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      galleryVisible = entries[0].isIntersecting;
    }, { threshold: 0 }).observe(gallery);
  }

  // Warm the second image immediately so the very first advance (auto or
  // manual) doesn't have to wait on a network round trip.
  preload(1);
  startAutoAdvance();

  // Scroll-down cue: nudge visitors past the fold, then get out of the way
  var scrollCue = document.getElementById('ScrollCue');
  if (scrollCue) {
    var toggleCue = function () {
      scrollCue.classList.toggle('is-hidden', window.scrollY > 60);
    };
    window.addEventListener('scroll', toggleCue, { passive: true });
    toggleCue();
    scrollCue.addEventListener('click', function () {
      window.scrollBy({ top: window.innerHeight * 0.55, behavior: 'smooth' });
    });
  }

  // Bundle selector: highlight + live price
  var priceEl = document.getElementById('ProductPrice');
  var stickyPrice = document.getElementById('StickyPrice');
  document.querySelectorAll('.bundle input[type="radio"]').forEach(function (radio) {
    radio.addEventListener('change', function () {
      document.querySelectorAll('.bundle').forEach(function (b) { b.classList.remove('is-selected'); });
      radio.closest('.bundle').classList.add('is-selected');
      if (priceEl && radio.dataset.price) priceEl.textContent = radio.dataset.price;
      if (stickyPrice && radio.dataset.price) stickyPrice.textContent = radio.dataset.price;
      var compare = document.getElementById('ComparePrice');
      if (compare) compare.textContent = radio.dataset.compare || '';
    });
  });

  // Sticky mobile ATC: show after scrolling past the buy form
  var form = document.getElementById('ProductForm');
  var sticky = document.getElementById('StickyATC');
  if (form && sticky) {
    var showAfter = function () {
      var rect = form.getBoundingClientRect();
      sticky.hidden = rect.bottom > 0;
    };
    window.addEventListener('scroll', showAfter, { passive: true });
    showAfter();
    var stickyBuy = document.getElementById('StickyBuy');
    if (stickyBuy) stickyBuy.addEventListener('click', function () { form.requestSubmit(); });
  }
})();
